<template>
    <div
            class="">
        <h4 class="text-center">Settings</h4>

        <!-- Automatic Sending Interval -->
        <div v-if="isSavable"
             class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span>Automatic Sending Interval</span>
            <select2 :options="intervals"
                     v-model:value="$data._interval"
                     :close-on-select="true"
            ></select2>
        </div>

        <!-- Day of week to send -->
        <div    v-if="permissions.can('manage_occupancy_report')
                              && interval === 'weekly'
                              && isSavable"
                class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
            <span>Day of Week to Send Report</span>
            <select2 :options="weekdayOptions"
                     v-model:value="$data._receiveWeekday"
                     :close-on-select="true"
            ></select2>
        </div>
    </div>
</template>

<script>
import axios from "axios"

import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

import Select2 from "@/components/elements/select2";
import Toggle from "@/components/elements/toggle.vue";

const INTERVALS = {
    daily: 'Daily',
    weekly: 'Weekly',
}

const WEEKDAY_OPTIONS = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
}

export default {
    name: "OccupancyReportSettings",
    mixins: [SonicuCoreMixin],
    components: {Toggle, Select2},
    props: {
      settings: Object,
        receiveWeekday: {
            type: [Number, String],
            default: 1,
        },
        semiMonthHalf: {
            type: String,
            default: 'first',
        },
        // TODO. include this in JS instead
        weekdayOptions: {
            type: Object,
            default: WEEKDAY_OPTIONS,
        },
        intervals: {
            type: Object,
            default: INTERVALS,
        },
        interval: {
            type: String,
            default: 'monthly',
        },
        isSavable: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            _receiveWeekday: this.receiveWeekday,
            _interval: this.interval,
            isSaving: false,
            _settings: this.settings,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      updateSettings(event, triggeringComponent = 'Unknown') {
        // Update the settings values based on the new local
        this.$emit('update:settings', this.$data._settings)
        this.$forceUpdate()
      },
      saveSettings() {
        this.$emit(`saveSettings`)
      },
    },
    computed: {},
    watch: {
        _interval(val, old) {
            if (val !== old) {
                this.$emit('update:interval', this.$data._interval)
            }
        },
        _receiveWeekday (val, old) {
            if (val !== old) {
                this.$emit('update:receiveWeekday', this.$data._receiveWeekday)
            }
        }
    },
}
</script>

<style scoped>

</style>